module.exports = __webpack_public_path__ + "static/media/tik-tok-logo.1c176476.svg";